/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Paging information
 */
export interface PagingDTO { 
    /**
     * Page number, first page is 0
     */
    pageNumber: number;
    /**
     * Number of items in the page
     */
    pageSize: number;
    /**
     * Total number of pages
     */
    pageCount: number;
    /**
     * Total number of elements
     */
    totalElements: number;
}

export class ClsPagingDTO { 
    /**
     * Page number, first page is 0
     */
    pageNumber: number = undefined;
    /**
     * Number of items in the page
     */
    pageSize: number = undefined;
    /**
     * Total number of pages
     */
    pageCount: number = undefined;
    /**
     * Total number of elements
     */
    totalElements: number = undefined;
}

